import { useContext } from "react";
import { ShopContext } from "../../context/ShopContext";

const CartTotal = () => {
    const {
        currency,
        delivery_fee,
        getCartAmount,
        navigate,
    } = useContext(ShopContext);

    const subtotal = getCartAmount();
    const total = subtotal + delivery_fee;

    return (

        <div className="cart-overview">
            <h3>Cart Totals</h3>
            <ul>
                <li>
                    <span>Subtotal</span>
                    <span>{currency}{subtotal}</span>
                </li>
                <li>
                    <span>Shipping</span>
                    <span>{currency}{delivery_fee}</span>
                </li>
                <li>
                    <strong>Total</strong>
                    <strong>{currency}{total}</strong>
                </li>
            </ul>


        </div>
    );
};

export default CartTotal;